/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Form, Input, Layout, Modal, Row, Spin, Switch } from 'antd';
import styles from './styles.module.scss';
// import './index.scss'
import styled from 'styled-components';
import { SelectStringInput } from '../../../../../select-input';
import { PlanType } from '../../../../../../utils/dict/PlanType';
import { Content } from 'antd/es/layout/layout';
import {
  IsAdminContext,
  NumberOfPlanContext,
  SkillListContext,
  UserPlanDataContext,
} from '../../../../../../../context';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../../../../axios_instance';
import { errorHandling } from '../../../../../../../utils/helper';
import Task from '../task';
import errorColumnMap from '../../../../../../../utils/error-message-mapping';
import ModalCloseIcon from '../../../../../icon';

const StyledModal = styled(Modal)`
  background-color: #303843;
  font-size: 32px;
  color: white;
  padding: 0px;
  border-radius: 4px;
  .ant-modal-close {
    position: absolute;
    top: 40px;
    right: 60px;
  }
  .ant-modal-content {
    background-color: #303843;
    padding: 30px;
    height: 620px;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      // box-shadow: inset 0 0 5px grey;
      // border: 2px solid white;
      border-radius: 0px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: rgba(158, 158, 158, 0.5);
      border-radius: 4px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: rgba(158, 158, 158, 1);
    }
  }
  .ant-modal-title {
    color: white;
    margin-left: 20px;
    font-size: 30px;
  }
  div {
    color: white;
  }
  .ant-modal-header {
    background-color: #303843;
  }
  .ant-upload-wrapper {
    margin: 20px;
  }
  .anticon {
    color: white;
  }
  .ant-btn-primary {
    height: 40px;
    width: 70px;

    background: #8cc63e;
    border-radius: 4px;
    margin-right: 20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    position: relative;
    bottom: -10px;
    right: 0px;
    margin-bottom: 20px;

    /* White */

    color: #ffffff;
  }

  .ant-btn-primary:disabled {
    height: 40px;
    width: 70px;

    background: #79808a;
    border-radius: 4px;
    margin-right: 20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    position: relative;
    bottom: -10px;
    right: 0px;
    margin-bottom: 20px;

    /* White */

    color: #9e9e9e;
  }
  .ant-btn-default {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;

    /* White */

    color: #ffffff;

    height: 40px;
    width: 80px;
    box-shadow: -2px 10px 30px rgba(0, 0, 0, 0.25);
    background: #303843;
    border-radius: 4px;
    position: relative;
    bottom: -10px;
    right: 0px;
    margin-bottom: 20px;
  }
`;

const StyledSelectStringInput = styled(SelectStringInput)`
  .ant-select-selector {
    height: 42px !important;
    background-color: #59606a !important;
    color: #d5d5d5 !important;
    padding-top: 6px !important;
  }
  .ant-select-item-option-selected {
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
    background-color: #303843 !important;
  }
  .ant-select-selection-placeholder {
    color: #d5d5d5 !important;
  }
  border-bottom: #59606a !important;
`;
const StyledInput = styled(Input)`
  background-color: #59606a !important;
  border: #59606a;
  height: 43px;

  color: #d5d5d5 !important;
  ::-webkit-calendar-picker-indicator {
    content: url(/calendar_today.png);
    background: #59606a;
  }
`;

interface PlanEditModalProps {
  isModalOpen: boolean;
  setIsModalOpen: any;
  id: string;
  skill_id: number;
  start_date: string;
  end_date: string;
  plan_type: any;
  task: Array<any>;
  show_in_resume: boolean;
}
const PlanEditModal: React.FC<PlanEditModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  id,
  skill_id,
  start_date,
  end_date,
  plan_type,
  task,
  show_in_resume
}: PlanEditModalProps) => {
  const [planData, setPlanData] = useState<{ [key: string]: any }>({
    skill_id,
    start_date,
    end_date,
    plan_type,
  });
  const [planType, setPlanType] = useState<number>(plan_type['id']);
  const [todo, setTodo] = useState<{ [key: string]: string | number }>({});
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const skillList = useContext(SkillListContext);
  const { userPlanData, setUserPlanData } = useContext(UserPlanDataContext);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { numberOfPlans, setNumberOfPlans } = useContext(NumberOfPlanContext);
  const handlePlanChange = (e: any) => {
    setPlanData((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  const handleTaskChange = (e: any) => {
    setTodo((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  const handleChangeResume = (value: any) => {
    setPlanData({
      ...planData,
      ["show_in_resume"]: value,
    });
  };

  const addTask = () => {
    setIsLoading(true)
    setErrorMessage({});
    // eslint-disable-next-line prefer-const
    let reqBody: any = {};
    reqBody['plan_id'] = id;
    reqBody['task'] = [];
    const taskBody: any = {
      ...todo,
      status: 2,
      spend_time: 0,
    };
    reqBody['task'].push(taskBody);

    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/plans';
      reqBody['profile_id'] = employeeId;
    } else {
      url = '/api/v1/profile/plans';
    }
    axiosInstance
      .post(url, reqBody)
      .then((response: any) => {
        const filteredPlanData = response.data.plans.filter((plan: any) => {
          return plan.status.id === 1;
        });
        setUserPlanData(filteredPlanData);
        setTodo({});
        // setIsModalOpen(false);
        form.resetFields();
      })
      .catch((error: any) => {
        errorHandling(error, setErrorMessage);
      })
      .finally(() => {
        setIsLoading(false)
      });
  };

  const handleOk = () => {
    editPlan();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setErrorMessage({});
    setPlanData({
      skill_id,
      start_date,
      end_date,
    });
    setPlanType(plan_type['id']);
  };

  const editPlan = () => {
    setErrorMessage({});
    console.log(planData);
    // eslint-disable-next-line prefer-const
    let reqBody: any = {};
    reqBody['plan_id'] = id;
    reqBody['plan_type'] = planType;
    reqBody['start_date'] = planData['start_date'];
    reqBody['end_date'] = planData['end_date'];
    reqBody['show_in_resume'] = 'show_in_resume' in planData ? planData['show_in_resume'] : show_in_resume;
    if (
      reqBody['plan_type'] !== plan_type['id'] ||
      reqBody['start_date'] !== start_date ||
      reqBody['end_date'] !== end_date ||
      reqBody['show_in_resume'] !== show_in_resume
    ) {
      setIsLoading(true)
      let url = '';
      if (isAdmin === '1') {
        url = '/api/v1/admin/profile/plans';
        reqBody['profile_id'] = employeeId;
      } else {
        url = '/api/v1/profile/plans';
      }
      axiosInstance
        .post(url, reqBody)
        .then((response: any) => {
          const filteredPlanData = response.data.plans.filter((plan: any) => {
            return plan.status.id === 1;
          });
          const orderedPlans = response.data.order.map((planId: number) =>
            filteredPlanData.find((plan: any) => plan.id === planId)
          ).filter((item: any) => item !== undefined);
          setUserPlanData(orderedPlans);
          setNumberOfPlans(orderedPlans.length);
          setIsModalOpen(false);
        })
        .catch((error: any) => {
          errorHandling(error, setErrorMessage);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsModalOpen(false);
    }
  };
  return (
    <>
      <StyledModal
        maskClosable={false}
        centered
        okText={'Save'}
        destroyOnClose
        // footer={null}
        closable
        title={
          <>
            New Plan
            <p className={styles['sub-title']}>Create a new plan here</p>
          </>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="80%"
        closeIcon={<ModalCloseIcon />}
      >
        <Spin spinning={isLoading}>
          {/* <p >Create a new plan here</p> */}
          <Row className={styles.row} justify="center">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", position: "absolute", bottom: "8px", right: "8px" }}><Switch defaultChecked={show_in_resume} onChange={handleChangeResume} /><span>Show in resume</span></div>
            <Col span={12} className={styles.col}>
              <Row className={styles.label}>Skill</Row>
              <Row>
                <StyledSelectStringInput
                  {...{
                    optionList: skillList,
                    setValue: 1,
                    width: 800,
                    placeHolder: 'Select Skill',
                    defaultValue: skill_id,
                    disabled: true,
                    dropDownBackground: '#59606a',
                  }}
                />
              </Row>
            </Col>
            <Col span={6} className={styles.col}>
              <Row className={styles.label}>Start Date</Row>
              <Row>
                <StyledInput
                  type="date"
                  name="start_date"
                  onChange={handlePlanChange}
                  defaultValue={start_date}
                  style={{
                    borderBottom:
                      'start_date' in errorMessage ? '1px solid red' : '',
                  }}
                ></StyledInput>
              </Row>
              <Row>
                <p style={{ color: 'red' }}>
                  {'start_date' in errorMessage ? errorMessage['start_date'] : ''}
                </p>
              </Row>
            </Col>
            <Col span={6} className={styles.col}>
              <Row className={styles.label}>End Date</Row>
              <Row>
                <StyledInput
                  type="date"
                  name="end_date"
                  onChange={handlePlanChange}
                  defaultValue={end_date}
                  style={{
                    borderBottom:
                      'end_date' in errorMessage ? '1px solid red' : '',
                  }}
                ></StyledInput>
              </Row>
              <Row>
                <p style={{ color: 'red' }}>
                  {'end_date' in errorMessage ? errorMessage['end_date'] : ''}
                </p>
              </Row>
            </Col>
          </Row>
          <Row className={styles['row']}>
            <Col span={12} className={styles.col}>
              <Row className={styles.label}>Plan Type</Row>
              <Row>
                <StyledSelectStringInput
                  {...{
                    optionList: Object.keys(PlanType).reduce(
                      (prev, current: any) => {
                        return { ...prev, [PlanType[current]]: current * 1 };
                      },
                      {}
                    ),
                    setValue: setPlanType,
                    width: 800,
                    placeHolder: 'Select Plan Type',
                    defaultValue: plan_type['id'],
                    dropDownBackground: '#59606a',
                  }}
                />
              </Row>
            </Col>
            <Col span={12} className={styles.col}></Col>
          </Row>
          <Row className={styles.row}>
            <p className={styles['to-do-title']}>To-Do</p>
          </Row>

          <Form form={form} onFinish={addTask}>
            <Row className={styles.row}>
              <Col span={19} className={styles.col}>
                <Form.Item
                  name="description"
                  label=""
                  rules={[
                    {
                      required: true,
                      message: 'Please fill up this field',
                    },
                    ({ getFieldValue }: any) => ({
                      validator(_: any, value: any) {
                        if (!value || value.length < 100) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            'Ensure the value has at most 100 characters.'
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <StyledInput
                    placeholder="Write Here"
                    name="description"
                    onChange={handleTaskChange}
                    required
                    style={{
                      borderBottom:
                        'description' in errorMessage ? '1px solid red' : '',
                    }}
                  ></StyledInput>
                </Form.Item>
                <Row>
                  <p style={{ color: 'red' }}>
                    {'description' in errorMessage
                      ? errorMessage['description']
                      : ''}
                  </p>
                </Row>
              </Col>
              <Col span={4} className={styles.col}>
                <Form.Item
                  initialValue={null}
                  name="duration"
                  label=""
                  // className="input-field"
                  rules={[
                    ({ getFieldValue }: any) => ({
                      validator(_, value) {
                        if (/^\d+$/.test(value) === true && value < 100000) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            'Please provide valid integer lower than 100000!'
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <StyledInput
                    placeholder="Time(hr)"
                    name="duration"
                    onChange={handleTaskChange}
                    required
                    style={{
                      borderBottom:
                        'duration' in errorMessage ? '1px solid red' : '',
                    }}
                  ></StyledInput>
                </Form.Item>
                <Row>
                  <p style={{ color: 'red' }}>
                    {'duration' in errorMessage
                      ? errorColumnMap['duration'] +
                      ' : ' +
                      errorMessage['duration']
                      : ''}
                  </p>
                </Row>
              </Col>
              <Col span={1}>
                <Form.Item>
                  <Button
                    type="text"
                    htmlType="submit"
                    style={{
                      marginRight: '10px',
                      marginLeft: 'auto',
                      float: 'right',
                      marginTop: '5px',
                    }}
                  >
                    <img src="/add_circle.png" style={{ cursor: 'pointer' }} />
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <Layout className={styles.layout}>
            <Content className={styles.container}>
              <Row className={styles['task-row']} style={{ marginTop: '0px' }}>
                <Col span={13} className={styles.col}>
                  <p className={styles['task-header']}>Description</p>
                </Col>
                <Col span={11} className={styles.col}>
                  <p className={styles['task-header']}>Time Spent</p>
                </Col>
              </Row>
              {task.map((item: any, index: number) => {
                return <Task {...{ ...item, plan_id: id }} key={index} />;
              })}
            </Content>
          </Layout>
        </Spin>
      </StyledModal>
    </>
  );
};

export default PlanEditModal;
